import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './auth-context.js';

/**
 * Reads the active auth context — the dev-token bypass or AuthKit, whichever
 * `AppProviders` mounted. Throws if rendered outside the provider chain.
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error('useAuth must be called inside <AppProviders>');
  }
  return ctx;
}
